export function hasTwoFactorEnabled(
	user: { twoFactorEnabled?: boolean | null } | null | undefined,
): boolean {
	return Boolean(user?.twoFactorEnabled);
}

export function getSafePostAuthRedirectTarget(
	rawRedirect: string | null | undefined,
	fallback = "/admin",
): string {
	if (!rawRedirect) return fallback;
	if (!rawRedirect.startsWith("/") || rawRedirect.startsWith("//")) {
		return fallback;
	}
	return rawRedirect;
}

export function buildRequiredTwoFactorSetupUrl(
	rawRedirect: string | null | undefined,
): string {
	const redirectTarget = getSafePostAuthRedirectTarget(rawRedirect);
	const params = new URLSearchParams({ required: "1" });

	if (redirectTarget !== "/admin") {
		params.set("redirect", redirectTarget);
	}

	return `/security?${params.toString()}`;
}
